var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9298",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10162"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38567",
    d: "M15.585 0a6.412 6.412 0 0 1 1.145.483 2.3 2.3 0 0 1 1 1.976c.006.241 0 .483 0 .765h.293c1.218 0 2.437-.005 3.655 0a2.414 2.414 0 0 1 1.06 4.616.335.335 0 0 0-.243.327c-.149 1.883-.309 3.765-.466 5.648l-.516 6.182c-.135 1.624-.279 3.247-.394 4.872a2.7 2.7 0 0 1-1.078 2.2 2.407 2.407 0 0 1-1.412.442H5.541A2.392 2.392 0 0 1 3.11 25.3c-.161-1.666-.286-3.336-.426-5q-.234-2.8-.465-5.6-.227-2.743-.451-5.487c-.03-.366-.053-.733-.1-1.1a.369.369 0 0 0-.182-.244A2.421 2.421 0 0 1 .171 4.742 2.449 2.449 0 0 1 2.5 3.225c1.209-.006 2.419 0 3.628 0h.348a9.437 9.437 0 0 1 .006-1.085A2.355 2.355 0 0 1 8.5.038.5.5 0 0 0 8.6 0zM3.293 8.074c.032.39.06.747.09 1.1l.4 4.818.462 5.54c.151 1.82.294 3.64.451 5.46.058.67.339.911 1.009.911H18.604a.793.793 0 0 0 .868-.764c.059-.534.1-1.07.143-1.6q.28-3.4.557-6.8.309-3.72.623-7.44c.034-.405.061-.811.092-1.224zm8.8-1.625h9.434a2.9 2.9 0 0 0 .322-.007.8.8 0 0 0 .647-1.136.87.87 0 0 0-.888-.472q-9.515.006-19.029 0a2.172 2.172 0 0 0-.242.006.8.8 0 0 0 0 1.6 2.989 2.989 0 0 0 .322.007h9.434M8.062 3.206h8.06V2.52a.822.822 0 0 0-.918-.908H8.922a.8.8 0 0 0-.856.748c-.018.275 0 .552 0 .845",
    transform: "translate(3.195 1.578)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38568",
    d: "M98.21 157.556c-.049-.815-.088-1.476-.129-2.137q-.2-3.269-.409-6.537c-.091-1.456-.177-2.912-.272-4.367a.8.8 0 0 0-1.14-.7.828.828 0 0 0-.466.887c.077 1.214.15 2.429.226 3.644l.572 9.136a.827.827 0 0 0 .849.871.784.784 0 0 0 .768-.8m8.807-11.958c.02-.348.055-.7.057-1.045a.8.8 0 0 0-1.6-.051c-.078 1.161-.146 2.322-.218 3.483l-.3 4.823c-.1 1.536-.2 3.072-.284 4.609a.812.812 0 0 0 .775.937.821.821 0 0 0 .835-.858q.083-1.407.172-2.813l.569-9.082m-4.776 5.474v-6.315c0-.646-.3-1.02-.806-1.02s-.807.375-.807 1.019v12.576a2.479 2.479 0 0 0 0 .269.782.782 0 0 0 .539.7.8.8 0 0 0 1.068-.836v-6.4",
    transform: "translate(-86.149 -132.483)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38569",
    d: "M98.209 157.556a.784.784 0 0 1-.768.8.827.827 0 0 1-.849-.871q-.284-4.568-.572-9.136c-.076-1.215-.149-2.429-.226-3.644a.829.829 0 0 1 .466-.887.8.8 0 0 1 1.14.7c.1 1.455.182 2.911.272 4.367q.2 3.269.409 6.537c.041.661.08 1.322.129 2.137",
    transform: "translate(-86.149 -132.483)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38570",
    d: "m229.978 145.632-.57 9.082q-.088 1.407-.172 2.814a.821.821 0 0 1-.835.858.812.812 0 0 1-.774-.936c.089-1.536.188-3.072.284-4.609l.3-4.823c.072-1.161.14-2.322.218-3.483a.8.8 0 0 1 1.6.051c0 .349-.037.7-.057 1.045",
    transform: "translate(-209.11 -132.517)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38571",
    d: "M169.256 151.11v6.4a.8.8 0 0 1-1.068.836.782.782 0 0 1-.539-.7 2.484 2.484 0 0 1 0-.269v-12.576c0-.644.3-1.02.807-1.019s.806.375.806 1.02v6.315",
    transform: "translate(-153.163 -132.521)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.e958213b283a26d5ca3dadfb78bd9a47.svg";
export { ForwardRef as ReactComponent };